import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { Queries } from '@shared/api';
import { API } from '@shared/types/api';
import { notNil } from '@shared/util/notNil';
import { useCurrentBusinessId } from './useCurrentBusinessId';

/**
 * A hook that uses a cache-first policy to retrieve channel list items.
 */
export function useChannelsLite(): { channels: API.ChannelListItemFragment[]; loading: boolean } {
  const businessId = useCurrentBusinessId();
  const { data, loading } = useQuery<API.ChannelListQuery>(Queries.channel.list, {
    skip: !businessId,
    fetchPolicy: 'cache-first',
  });

  return useMemo(
    () => ({
      channels: (data?.listChannels?.filter(notNil) ?? []) as API.ChannelListItemFragment[],
      loading,
    }),
    [data?.listChannels, loading],
  );
}
